import { useLocation, useSearchParams } from "react-router-dom"
import { useAppDependencies } from "../../context/AppContext"
import LandingPage from "../search/LandingPage"
import OldUrlRedirect from "./OldUrlRedirect"
import PlanModal from "../premium/PlanModal"
import LoginModal from "../login/LoginModal"
import "./AddressUnavailableNotice.css"

export default function HomePageWithRedirect() {
    const [searchParams] = useSearchParams()
    const path = searchParams.get('path')
    const deps = useAppDependencies()
    const location = useLocation()
    const addressUnavailable = !!(location.state as { addressUnavailable?: boolean } | null)?.addressUnavailable

    if (path) {
        return <OldUrlRedirect />
    }

    return (
        <>
            {addressUnavailable && (
                <div className="address-unavailable-notice" role="status">
                    That address isn't available. Try searching for another address.
                </div>
            )}
            <LandingPage
                stateHandler={deps.stateHandler}
                apiHandler={deps.apiHandler}
                errorHandler={deps.errorHandler}
                loader={deps.loader}
                loginHelper={deps.loginHelper}
               
            />
            <PlanModal stateHandler={deps.stateHandler} apiHandler={deps.apiHandler} />
            <LoginModal stateHandler={deps.stateHandler} loginHelper={deps.loginHelper} apiHandler={deps.apiHandler} />
        </>
    )
}
